export const selectTenantsList = (state) => state.tenants.list;
export const selectTenantsLoading = (state) => state.tenants.loading;
export const selectTenantsError = (state) => state.tenants.error;
export const selectTenantLoading = (state) => state.tenants.loadingTenant;
export const selectTenant = (state) => state.tenants.selected;
export const selectTenantError = (state) => state.tenants.tenantError;
export const selectAddTenantLoading = (state) => state.tenants.addTenantLoading;
